import React, { useEffect } from "react"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Input,
  Container,
} from "reactstrap"
import {
  addSpaceEveryNChars,
  getBusinsessAddress,
  getInvestorsStatus,
  renderAddressValue,
  showRegistrationType,
} from "helpers/common"
import useFetchKycData from "hooks/useFetchKycData"
import FullPageLoader from "components/fullPageLoader"
import { useSelector } from "react-redux"

const CompanyInfo = ({}) => {
  const { kycData, isLoading, user, navigate } = useFetchKycData()
  const { userType } = useSelector((state) => state.user)

  useEffect(() => {
    if (user.entity_type !== "COMPANY") {
      navigate("/dashboard")
    }
  }, [user])

  return (
    <div className="page-content">
      <Container fluid>
        {isLoading && <FullPageLoader />}

        {!isLoading && user?.status === "APPROVED" && kycData && (
          <div className="mt-4">
            <Card>
              <CardBody className="pt-4">
                <div className="d-flex align-items-center mb-4 justify-content-between ">
                  <CardTitle className="heading-badge">
                    <span>
                      {" "}
                      {userType === "INVESTOR" ? "Company" : "Entity"}{" "}
                      Information
                    </span>
                  </CardTitle>
                  {kycData && (
                    <div className="code-status">
                      {getInvestorsStatus(kycData?.status)}
                    </div>
                  )}
                </div>

                <Row>
                  <Col xl={12}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Name of the Entity
                        </Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorCompanyDetails?.entity_name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Date of Incorporation
                        </Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.investorCompanyDetails
                              ?.date_of_incorporation
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Constitution of Business
                        </Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.investorCompanyDetails
                              ?.constitution_of_business
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Registered Address
                        </Label>
                        <Input
                          disabled
                          name="name"
                          type="textarea"
                          className="form-control"
                          value={getBusinsessAddress(
                            kycData?.investorCompanyDetails
                          )}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Communication Address
                        </Label>
                        <Input
                          disabled
                          name="name"
                          type="textarea"
                          className="form-control"
                          value={
                            kycData?.investorCompanyDetails
                              ?.is_comm_address_same === "SAME"
                              ? getBusinsessAddress(
                                  kycData?.investorCompanyDetails
                                )
                              : renderAddressValue(
                                  kycData?.investorCompanyDetails
                                    ?.communication_address
                                )
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">PAN</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.pan_no}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">GSTIN</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.investorCompanyDetails?.gstin ||
                            "Not Applicable"
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Phone No.</Label>
                        <Input
                          disabled
                          name="phone"
                          type="text"
                          className="form-control"
                          value={kycData?.phone}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Email Address</Label>
                        <Input
                          disabled
                          name="email"
                          type="text"
                          className="form-control"
                          value={kycData?.email}
                        />
                      </Col>
                      {userType === "INVESTOR" && (
                        <Col xl={6}>
                          <Label className="col-form-label">
                            Political Exposure
                          </Label>
                          <Input
                            disabled
                            name="email"
                            type="text"
                            className="form-control"
                            value={
                              kycData?.businessAdditionalDetails
                                ?.politicalExposure
                            }
                          />
                        </Col>
                      )}
                      <Col xl={6}>
                        <Label className="col-form-label">
                          {userType === "INVESTOR" ? "Company" : "Entity"}{" "}
                          Registration No.
                          {kycData?.businessAdditionalDetails
                            ?.entity_registration_no
                            ? `(${showRegistrationType(
                                kycData?.businessAdditionalDetails
                                  ?.constitution_of_business
                              )})`
                            : ""}
                        </Label>
                        <Input
                          disabled
                          name="email"
                          type="text"
                          className="form-control"
                          value={
                            kycData?.businessAdditionalDetails
                              ?.entity_registration_no || "Not Applicable"
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  )
}

export default CompanyInfo
